import React, { useEffect } from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface LoadingScreenProps {
  onComplete: () => void;
}
export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  onComplete
}) => {
  useEffect(() => {
    // Redirect after 2 seconds
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="min-h-screen flex flex-col bg-gradient-to-br from-dark-900 to-dark-800 font-sans" data-id="element-29">
      {/* Top security banner */}
      <div className="bg-accent-green py-1 text-center shadow-md z-10" data-id="element-30">
        <p className="text-xs font-bold tracking-wider text-white uppercase flex justify-center items-center gap-2" data-id="element-31">
          <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" data-id="element-32"></span>
          AUTENTIKASI BERHASIL - MENGAKSES SISTEM
          <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" data-id="element-33"></span>
        </p>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 relative overflow-hidden" data-id="element-34">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-20" data-id="element-35"></div>

        <div className="text-center relative z-10 max-w-md w-full" data-id="element-36">
          {/* Logo */}
          <div className="mb-6 flex flex-col items-center justify-center" data-id="element-37">
            <div className="relative mb-4" data-id="element-38">
              <div className="absolute inset-0 bg-primary blur-2xl opacity-20 rounded-full animate-pulse" data-id="element-39"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hFLsea95KTbfu8th3Tcctj/logo-BIN-NEW.png" alt="BIN Logo" className="h-24 relative z-10" data-id="element-40" />
            </div>
            <h1 className="text-3xl font-bold text-white tracking-tight mb-1" data-id="element-41">
              ARSENA
            </h1>
            <p className="text-xs text-primary font-medium tracking-wide uppercase" data-id="element-42">
              Asset Resource Strategic Enterprise Network
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-43">
              for Advanced-Technology
            </p>
          </div>

          {/* Success Icon */}
          <div className="flex justify-center mb-8" data-id="element-44">
            <div className="relative" data-id="element-45">
              <div className="absolute inset-0 bg-accent-green rounded-full opacity-20 animate-ping" data-id="element-46"></div>
              <div className="relative p-4 bg-accent-green/10 border border-accent-green/30 rounded-full backdrop-blur-sm" data-id="element-47">
                <CheckCircleIcon className="h-12 w-12 text-accent-green" data-id="element-48" />
              </div>
            </div>
          </div>

          {/* Text */}
          <h2 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-49">
            Verifikasi Identitas Berhasil
          </h2>
          <p className="text-gray-400 mb-8 text-sm" data-id="element-50">
            Mempersiapkan lingkungan kerja aman...
          </p>

          {/* Progress Bar */}
          <div className="mt-8 w-full max-w-xs mx-auto" data-id="element-51">
            <div className="flex justify-between text-xs text-gray-500 mb-2 font-mono" data-id="element-52">
              <span data-id="element-53">ENKRIPSI</span>
              <span data-id="element-54">100%</span>
            </div>
            <div className="h-1.5 bg-dark-700 rounded-full overflow-hidden border border-dark-600" data-id="element-55">
              <div className="h-full bg-gradient-to-r from-primary via-primary-light to-primary rounded-full animate-progress shadow-[0_0_10px_rgba(242,195,0,0.5)]" data-id="element-56"></div>
            </div>
            <div className="mt-2 text-[10px] text-gray-600 font-mono text-right" data-id="element-57">
              SECURE CONNECTION ESTABLISHED
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="py-3 px-6 bg-dark-900 border-t border-dark-700" data-id="element-58">
        <div className="text-center text-xs text-gray-600 font-mono" data-id="element-59">
          SYSTEM ID: {Math.random().toString(36).substr(2, 9).toUpperCase()} •
          ENCRYPTION: AES-256
        </div>
      </div>
      <style jsx data-id="element-60">{`
        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }
        .animate-progress {
          animation: progress 2s ease-in-out;
        }
      `}</style>
    </div>;
};